export default __webpack_public_path__ + "static/media/4.a3bb7d9e.png";